import { ENV_ENUM, getConfig } from '../configProvider';

export function getRootDomain() {
    const hostname = window.location.hostname;
    // 分割域名为各个部分
    const parts = hostname.split('.').reverse();
    // 如果域名部分少于两个，直接返回
    if (parts.length < 2) {
        return hostname;
    }
    // 常见的二级顶级域名（ccTLDs）列表
    const commonTlds = ['co', 'com', 'org', 'net', 'gov', 'edu', 'mil'];
    // 获取根域名
    let rootDomain = parts[1] + '.' + parts[0];
    // 处理二级顶级域名情况
    if (commonTlds.includes(parts[1].toLowerCase()) && parts.length > 2) {
        rootDomain = parts[2] + '.' + rootDomain;
    }
    return rootDomain;
}

export const getSuffix = () => {
    const { env } = getConfig();
    let suffix = `--${env}`;
    if (env === ENV_ENUM.release) {
        suffix = '';
    }
    return suffix;
};

/**
 * 获取服务端真正需要上报的语言值
 * @param locale 语言
 * @returns
 */
export const getClientLanguage = (locale: string) => {
    const fankuiLangMap: any = {
        cn: 'zh-Hans',
        tw: 'zh-Hant',
        en: 'en',
        jp: 'ja',
        kr: 'ko',
        pt: 'pt',
        es: 'es',
        de: 'de',
        id: 'id',
        th: 'th',
        'zh-Hant': 'zh-Hant',
        'zh-Hans': 'zh-Hans',
    };

    return fankuiLangMap[locale] || '';
};

/**
 * 获取country_code
 * @param language  通过navigator.language获取的值
 * @returns
 */

export const getCountryCode = () => {
    const language = navigator.language;
    const regionMap: { [key: string]: string } = {
        'zh-CN': 'CN',
        'zh-TW': 'TW',
        'ja-JP': 'JP',
        'ko-KR': 'KR',
        'en-US': 'US',
        'en-AU': 'AU',
        'en-CA': 'CA',
        'zh-HK': 'HK',
        'th-TH': 'TH',
        'en-GB': 'GB',
        'en-SG': 'SG',
        'ms-SG': 'SG',
        'zh-SG': 'SG',
        'vi-VN': 'VN',
        'zh-MO': 'MO',
        'pt-MO': 'MO',
        'tl-PH': 'PH',
        'en-PH': 'PH',
        'id-ID': 'ID',
        'en-NZ': 'NZ',
        'mi-NZ': 'NZ',
        fil: 'PH',
    };

    if (regionMap[language]) {
        return regionMap[language];
    }
    // 如果有区域代码，格式是 <language>-<region>，
    // 例如：en-US — 英语（美国）、zh-CN — 简体中文（中国）
    if (language && language.includes('-')) {
        const [_, rg] = language.split('-');
        if (rg) {
            return rg;
        }
    }
    // 用语言匹配
    const keys = Object.keys(regionMap);
    for (let i = 0; i < keys.length; i++) {
        const element = keys[i];
        if (element.includes(language)) {
            return regionMap[element];
        }
    }

    return '';
};

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
